import { useCallback, useEffect, useState } from 'react';
import { BarChart3, Check } from 'lucide-react';
import { SECTION_COLOR, SECTION_BG, SECTION_BORDER, hlavicky } from './komunikace';

/** Karta ankety ve zprávě — hlasování klepnutím, sloupky výsledků. */
export default function AnketaKarta({ id, obnova = 0, isDark }) {
    const [d, setD] = useState(null);
    const [bezi, setBezi] = useState(false);

    const nacti = useCallback(() => {
        fetch(`/api/ankety/${id}`).then(r => (r.ok ? r.json() : null)).then(x => x && setD(x)).catch(() => {});
    }, [id]);
    useEffect(() => { nacti(); }, [nacti, obnova]);

    const hlasovat = async (moznostId) => {
        if (!d || d.uzavreno || bezi) return;
        const moje = d.moznosti.filter(m => m.moje).map(m => m.id);
        const nove = d.vice ? (moje.includes(moznostId) ? moje.filter(x => x !== moznostId) : [...moje, moznostId]) : (moje.includes(moznostId) ? [] : [moznostId]);
        setBezi(true);
        try {
            const res = await fetch(`/api/ankety/${id}/hlasovat`, { method: 'POST', headers: hlavicky(), body: JSON.stringify({ moznosti: nove }) });
            if (res.ok) setD(await res.json());
        } finally { setBezi(false); }
    };
    const uzavrit = async () => {
        const res = await fetch(`/api/ankety/${id}/uzavrit`, { method: 'POST', headers: hlavicky(false) });
        if (res.ok) setD(await res.json());
    };

    if (!d) return <div className="rounded-xl text-sm" style={{ border: `1px solid ${SECTION_BORDER}`, padding: '12px 14px', color: 'var(--text-muted)', width: 'min(420px, 100%)' }}>Načítám anketu…</div>;

    const max = Math.max(1, ...d.moznosti.map(m => m.pocet));
    const hlasoval = d.moznosti.some(m => m.moje);
    const hrana = isDark ? 'rgba(255,255,255,0.12)' : 'var(--border-default)';

    return (
        <div className="rounded-xl" onClick={e => e.stopPropagation()}
            style={{ border: `1px solid ${d.uzavreno ? hrana : SECTION_BORDER}`, background: isDark ? 'rgba(255,255,255,0.035)' : 'rgba(0,0,0,0.02)', padding: '12px 14px', width: 'min(420px, 100%)' }}>
            <div className="flex items-center gap-2" style={{ marginBottom: 8 }}>
                <BarChart3 size={16} style={{ color: SECTION_COLOR, flexShrink: 0 }} />
                <b className="flex-1" style={{ color: 'var(--text-primary)', fontSize: 14.5 }}>{d.otazka}</b>
            </div>
            <div className="flex flex-col" style={{ gap: 6 }}>
                {d.moznosti.map(m => (
                    <button key={m.id} type="button" onClick={() => hlasovat(m.id)} disabled={d.uzavreno}
                        className="relative text-left rounded-lg overflow-hidden"
                        style={{ minHeight: 40, padding: '0 12px', border: `1px solid ${m.moje ? SECTION_COLOR : hrana}`, background: 'transparent', cursor: d.uzavreno ? 'default' : 'pointer' }}
                        title={m.kdo?.length ? m.kdo.join(', ') : undefined}>
                        {(hlasoval || d.uzavreno) && <span aria-hidden="true" style={{ position: 'absolute', inset: 0, width: `${Math.round((m.pocet / max) * 100)}%`, background: SECTION_BG }} />}
                        <span className="relative flex items-center gap-2" style={{ minHeight: 38 }}>
                            {m.moje && <Check size={14} style={{ color: SECTION_COLOR }} />}
                            <span className="flex-1 text-[13.5px]" style={{ color: 'var(--text-primary)' }}>{m.text}</span>
                            {(hlasoval || d.uzavreno) && <span className="text-xs tabular-nums font-semibold" style={{ color: 'var(--text-secondary)' }}>{m.pocet}</span>}
                        </span>
                    </button>
                ))}
            </div>
            <div className="flex items-center gap-2 text-xs" style={{ marginTop: 8, color: 'var(--text-muted)' }}>
                <span className="flex-1">
                    Hlasovalo {d.hlasujicich} z {d.clenu}{d.vice ? ' · víc možností' : ''}{d.anonymni ? ' · anonymní' : ''}{d.uzavreno ? ' · uzavřeno' : ''}
                </span>
                {d.je_autor && !d.uzavreno && <button type="button" onClick={uzavrit} style={{ background: 'none', border: 'none', color: SECTION_COLOR, cursor: 'pointer', fontWeight: 600 }}>Uzavřít</button>}
            </div>
        </div>
    );
}
